import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { percentageFilter } from "app/filters/ngFilters";
import { ZERO } from "app/pages/activation/components/HomeWithData/ShareData/constants";
import { gradientDefault } from "app/pages/activation/components/Shared/LineChart/configs";
import { LineChart } from "app/pages/activation/components/Shared/LineChart/LineChart";
import { addPercentPoint } from "app/pages/activation/helpers/format";
import type { DatedValueTrendItem } from "app/pages/activation/types/api";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";

import { CHART_HEIGHT, TIME_PERIOD } from "./constants";
import * as SC from "./styles";

interface IDefaultWidgetSchema {
    trendData?: DatedValueTrendItem[];
    share?: number | null;
    difference?: number | null;
}

const Default = ({ trendData, share: rawShare, difference: rawDifference }: IDefaultWidgetSchema) => {
    const share = rawShare ?? 0;
    const difference = rawDifference ?? 0;
    const preparedData = trendData ? trendData.map(({ key, value }) => ({ key, value: value?.value ?? 0 })) : [];

    return (
        <SC.Container>
            <SC.MetricRow>
                <SC.Share>{FORMATTERS.percentSign(share, DEFAULT_DECIMAL)}</SC.Share>
            </SC.MetricRow>
            <SC.Difference>
                <ChangeIndication
                    className="customChangeIndication"
                    changeValue={`${addPercentPoint(percentageFilter()(difference, 2))} ${TIME_PERIOD}`}
                    isIncreasing={difference > ZERO}
                    isNotChanged={difference === ZERO}
                />
            </SC.Difference>
            <SC.ChartContainer>
                <LineChart
                    height={CHART_HEIGHT}
                    data={preparedData}
                    tooltipEnabled
                    gradient={gradientDefault}
                />
            </SC.ChartContainer>
        </SC.Container>
    );
};

export default Default;
